import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { Card } from "@/components/ui/card";

const FeesCalculator = () => {
  const [volume, setVolume] = useState([100000]); // Default $100k

  const formatCurrency = (value: number) => {
    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(1)}M`;
    } else if (value >= 1000) {
      return `$${(value / 1000).toFixed(0)}k`;
    }
    return `$${value}`;
  };

  const totalFees = volume[0] * 0.03; // 3% of volume
  const creatorFees = totalFees * 0.33; // 33% of total fees
  const lpFees = totalFees * 0.4; // 40% of total fees
  const platformFees = totalFees * 0.27; // 27% of total fees

  return (
    <Card className="p-6 space-y-6 bg-primary/5 border-primary/20">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <label className="text-lg font-semibold">Trading Volume</label>
          <span className="text-2xl font-bold text-primary">
            {formatCurrency(volume[0])}
          </span>
        </div>
        
        <Slider
          value={volume}
          onValueChange={setVolume}
          min={10000}
          max={10000000}
          step={10000}
          className="w-full"
        />
        
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>$10k</span>
          <span>$10M</span>
        </div>
      </div>

      <div className="space-y-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Total Fees (3%)</span>
          <span className="text-lg font-semibold">{formatCurrency(totalFees)}</span>
        </div>

        <div className="space-y-3 pl-4 border-l-2 border-primary/20">
          <div className="flex items-center justify-between">
            <span className="text-sm">Market Creator (33%)</span>
            <span className="font-medium text-primary">{formatCurrency(creatorFees)}</span>
          </div>
          
          <div className="flex items-center justify-between">
            <span className="text-sm">Liquidity Providers (40%)</span>
            <span className="font-medium text-primary">{formatCurrency(lpFees)}</span>
          </div>
          
          <div className="flex items-center justify-between">
            <span className="text-sm">KBETS Platform (27%)</span>
            <span className="font-medium text-primary">{formatCurrency(platformFees)}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default FeesCalculator;